import React, { useContext } from "react";
import { AuthContext } from "@app/providers";
import ParentUserProfile from "./parentUserProfile";
import StudentUserProfile from "./studentUserProfile";
import EducatorUserProfile from "./educatorUserProfile";
export default function UserProfile() {
  const { userInfo }: any = useContext(AuthContext);
  const {
    userJson: { userType }
  } = userInfo;
  const profileType = userInfo && userType;
  return (
    <>
      {profileType === "student" && <StudentUserProfile />}
      {profileType === "parent" && <ParentUserProfile />}
      {profileType === "educator" && <EducatorUserProfile />}
    </>
  );
}
